module.exports = __webpack_public_path__ + "c19c1502fe189cb922bde7e1e120e720.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/Footer2/Testimonials/JNI_2clr.png
// module id = 561
// module chunks = 16